import React from "react"
import AuthContextProvider from "./src/contexts/user-context"
import OrganizationProvider from "./src/contexts/org-context"
import StripeContextProvider from "./src/contexts/stripe-context"

export const wrapRootElement = ({element}) => (
        <AuthContextProvider>
            <OrganizationProvider>
                <StripeContextProvider>
                    { element }
                </StripeContextProvider>
            </OrganizationProvider>
        </AuthContextProvider>
)

